import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 216 56"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0060e6",
      "fill-rule": "evenodd",
      d: "M95.883 6.744v10.33h8.534v8.536h-8.534v16.732c0 2.987 1.655 4.353 4.442 4.353 1.654 0 3.483-.512 4.702-1.28v9.39c-1.48.769-4.093 1.195-6.966 1.195-7.925 0-12.889-3.842-12.889-12.293V25.61H79.25v-8.537h5.922V6.744zM183.657.85C206.38.85 216 12.932 216 28.046s-9.62 27.196-32.343 27.196h-9.272V.85zm-40.483 30.595c12.5 0 22.686 6.884 24.231 23.296l.045.5h-48.551c1.384-16.772 11.65-23.796 24.275-23.796M10.364 2.818 26.56 27.573 42.67 2.818h10.19v52.414H41.887V21.428l-15.24 22.535h-.349L10.886 21.428v33.804H0V2.818zm63.051 14.255v38.159H62.617V17.073zM143.175 0c7.42 0 13.437 5.898 13.437 13.173s-6.016 13.173-13.438 13.173-13.438-5.897-13.438-13.173S135.752 0 143.174 0m-75.16 0c3.536 0 6.402 2.81 6.402 6.275s-2.866 6.274-6.401 6.274-6.4-2.809-6.4-6.274c0-3.466 2.865-6.275 6.4-6.275"
    }, null, -1)
  ])))
}
export default { render: render }